import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { EMPLOYEE_TRAKING_API } from "../constants/constants";
import { defaultErrorMsg, defaultHeaders } from "../utils/params";

export const employeeTrackingApi = createApi({
  reducerPath: "employeeTrackingApi",
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: EMPLOYEE_TRAKING_API,
      prepareHeaders: async (headers, { getState }) => {
        const token = (getState() as any)?.auth?.access_token;

        return defaultHeaders(headers, token);
      },
    });

    const result = await baseQuery(args, api, extraOptions);

    await defaultErrorMsg(result);

    return result;
  },
  keepUnusedDataFor: 2,
  endpoints: () => ({}),
});
